module.exports = __webpack_public_path__ + "img/main-pic.c8654c15.png";